var Formatter = {
    format: function (value, row, index) {
        var columnName = this.field;
        var newVal = DefaultValueConverter.convert(value, columnName);
        return newVal;
    }
};

var PasswordFormatter = {
    format: function (value, row, index) {
        return DefaultValueConverter.convertPassword(value);
    }
};

// Converts also BoolToIcon, if it's renamed than the converters in the other UIs have to be renamed as well
var BoolToLocalStringConverter = {
    format: function (value, row, index) {
        return DefaultValueConverter.convertByteToIcon(value);
    }
}

var UserFlagToStringFormatter = {
    format: function (value, row, index) {
        return DefaultValueConverter.convertUserFlagToString(value);
    }
};

var CulturedDoubleFormatter = {
    format: function (value, row, index) {
        if (typeof (value) === 'undefined') {
            return undefined;
        }

        return DefaultValueConverter.convertToCulturedDouble(value);
    }
}

globalThis.Formatter = Formatter;
globalThis.PasswordFormatter = PasswordFormatter;
globalThis.BoolToLocalStringConverter = BoolToLocalStringConverter;
globalThis.UserFlagToStringFormatter = UserFlagToStringFormatter;
globalThis.CulturedDoubleFormatter = CulturedDoubleFormatter;